<template>
  <div
    v-if="ready"
    class="w-full template"
  >
    <h1>Erweiterungen verwalten</h1>
    <div class="mt-4 alert alert-info">
      Hier können Sie die gewünschten Erweiterungen per Klick buchen. Eine gebuchte Erweiterung wird sofort aktiviert.<br>
      Alle Erweiterungen können hier ebenso wieder per Klick gekündigt werden, haben eine Kündigungsfrist von einem Monat ab Kündigung und werden Stundengenau abgerechnet.
    </div>

    <h3 class="pt-8">
      Gebuchte Erweiterungen
    </h3>
    <ul v-if="hasActiveAddons > 0">
      <li
        v-for="addon in addons.booked"
        :key="addon.id"
        class="py-2"
      >
        {{ addon.title }}
        <span v-if="addon.price_per_month != 0">({{ addon.price_per_month | price }} / Monat)</span>
        <span v-if="addon.price_per_car != 0">({{ addon.price_per_car | price }} / Fahrzeug)</span>
        <span v-if="addon.price_per_month == 0 && addon.price_per_car == 0">(kostenlos)</span><br>
        <a
          v-if="!addon.stop"
          href="javascript:void(0);"
          @click="cancel(addon)"
        >&raquo; Erweiterung kündigen<br></a>
        <a
          v-if="!addon.stop && isRoot"
          href="javascript:void(0);"
          @click="cancel(addon, true)"
        >&raquo; Erweiterung sofort kündigen (ADMIN)<br></a>
        <span
          v-if="addon.stop"
          class="font-bold text-red-600"
        >
          Gekündigt zum {{ addon.stop | date }}<br>
          <a
            href="javascript:void(0);"
            @click="revertCancel(addon)"
          >&raquo; Kündigung widerrufen</a>
        </span>
      </li>
    </ul>
    <p v-if="hasActiveAddons < 1">
      Sie haben noch keine aktiven Erweiterungen
    </p>

    <h3 class="pt-8">
      Verfügbare Erweiterungen
    </h3>
    <div
      v-if="hasAvailableAddons > 0"
      class="flex flex-wrap"
    >
      <template v-for="addon in availableAddons">
        <div
          v-if="addon.visible == 'Y'"
          :key="addon.id"
          class="w-full p-2 md:w-1/2 xl:w-1/3"
        >
          <div class="w-full h-full p-8 text-black border-4 rounded border-orange-mia">
            <div class="pb-2 text-xl font-bold">
              {{ addon.title }}
            </div>
            <!-- eslint-disable vue/no-v-html -->
            <div
              class="mb-6"
              v-html="addon.content"
            />
            <!-- eslint-enable vue/no-v-html -->
            <a
              href="javascript:void(0);"
              class="font-bold text-black"
              @click="book(addon)"
            >
              &raquo;
              <span v-if="addon.price != 0">für {{ addon.price | price }}</span>
              <span v-if="addon.price_per_month != 0">für {{ addon.price_per_month | price }} / Monat</span>
              <span v-if="addon.price_per_car != 0">für {{ addon.price_per_car | price }} / Fahrzeug</span>
              <span v-if="addon.price_per_month == 0 && addon.price_per_car == 0 && addon.price == 0">kostenlos</span>
              <span
                v-if="addon.bookable == 'Y'"
                class="px-1"
              >hinzufügen</span>
              <span
                v-if="addon.bookable == 'N'"
                class="px-1"
              >anfragen</span>
            </a>
          </div>
        </div>
      </template>
    </div>
    <p v-if="hasAvailableAddons < 1">
      Sie haben alle verfügbaren Erweiterungen gebucht 🎉
    </p>

    <div class="pt-16">
      <h3>Couponcode einlösen</h3>
      <p>Sie haben einen Couponcode für eine Erweiterung erhalten? Lösen Sie ihn hier ein:</p>
      <input
        v-model="couponcode"
        type="text"
        class="p-2 border rounded border-orange-mia"
      >
      <input
        v-if="!couponLoading"
        type="button"
        class="p-2 ml-2 border rounded border-orange-mia hover:bg-orange-mia hover:text-white"
        value="Einlösen"
        @click="redeemCouponcode()"
      >
    </div>

    <div class="pt-16">
      <h3>Weitere Angebote</h3>
      <p>Bitte kontaktieren Sie uns für eine individuelle Einrichtung: <a href="mailto:service@carana.net?subject=Individuelle%20Einrichtung">service@carana.net</a></p>
    </div>

    <p class="pt-16 text-sm">
      Alle Preise sind netto zzgl. {{ vatRate | vatLabel }} Umsatzsteuer.
    </p>
  </div>
</template>

<script>
import _ from 'lodash'
import CalculatesVat from '@/mixins/CalculatesVat'

export default {
  mixins: [CalculatesVat],

  data() {
    return {
      ready: false,
      addons: [],
      couponcode: '',
      couponLoading: false
    }
  },

  computed: {
    availableAddons() {
      return this.addons.available
    },

    hasActiveAddons() {
      return (_.size(this.addons.booked) > 0)
    },

    hasAvailableAddons() {
      return (_.size(this.addons.available) > 0)
    }
  },

  mounted() {
    eventBus.$emit('mia-loading-ended')
    eventBus.$emit('mia-set-breadcrumb', [
      {
        link: {
          path: '/addons'
        },
        text: 'Erweiterungen verwalten'
      }
    ])

    this.loadData()
  },

  methods: {
    loadData() {
      axios.get(`${window.baseUrl}/user/addons`)
        .then(({ data }) => {
          this.addons = data
          this.ready = true
        }).catch(() => {
          this.addons = []
        })
    },

    redeemCouponcode() {
      this.couponLoading = true
      axios.post(`${window.baseUrl}/user/addfeaturebycouponcode`, {
        couponcode: this.couponcode
      })
        .then(({ data }) => {
          this.couponLoading = false
          if (data.success) {
            eventBus.$emit('mia-info', {
              info: [data.message]
            })

            this.couponcode = ''
            this.loadData()
          }
        })
    },

    book(addon) {
      let priceText = []

      if (addon.price_per_month > 0) {
        priceText.push(`${this.$options.filters.price(addon.price_per_month)} / Monat`)
      }

      if (addon.price_per_car > 0) {
        priceText.push(`${this.$options.filters.price(addon.price_per_car)} / Fahrzeug`)
      }

      if (addon.price_per_month === 0 && addon.price_per_car === 0 && addon.price === 0) {
        priceText = ['kostenlos']
      }

      // eslint-disable-next-line no-multi-spaces
      const taskRequest   = addon.bookable === 'Y' ? 'buchen' : 'anfragen'
      const taskRequested = addon.bookable === 'Y' ? 'freigeschaltet' : 'angefragt'

      // eslint-disable-next-line no-alert
      if (window.confirm(`Erweiterung "${addon.title}" (${priceText.join(' sowie ')}) ${taskRequest}?`)) {
        axios.post(`${window.baseUrl}/user/addfeature`, {
          feature: addon.id
        })
          .then(() => {
            eventBus.$emit('mia-get-userdata')
            eventBus.$emit('mia-info', {
              info: [`Vielen Dank für Ihre Bestellung. Die gewünschte Erweiterung wurde ${taskRequested}.`]
            })

            this.loadData()
          })
      }
    },

    cancel(addon, instant) {
      // eslint-disable-next-line no-param-reassign
      instant = (typeof instant !== 'undefined')

      // eslint-disable-next-line no-alert
      if (window.confirm(`Erweiterung "${addon.title}" ${instant ? 'SOFORT' : 'zum nächstmöglichen Termin'} kündigen?`)) {
        axios.post(`${window.baseUrl}/user/cancelfeature`, {
          id: addon.id,
          instant
        })
          .then(() => {
            eventBus.$emit('mia-info', {
              info: ['Die gewünschte Erweiterung wird zum nächstmöglichen Termin gekündigt.']
            })

            this.loadData()
          })
      }
    },

    revertCancel(addon) {
      // eslint-disable-next-line no-alert
      if (window.confirm(`Kündigung der Erweiterung "${addon.title}" widerrufen?`)) {
        axios.post(`${window.baseUrl}/user/revertcancelfeature`, {
          id: addon.id
        })
          .then(() => {
            eventBus.$emit('mia-info', {
              info: [`Die Kündigung der Erweiterung "${addon.title}" wurde widerrufen.`]
            })

            this.loadData()
          })
      }
    }
  }
}
</script>

<style scoped>

</style>
